/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staples_TitleInputs */

const en_staples_title = /** @type {(inputs: Staples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staples`)
};

const de_staples_title = /** @type {(inputs: Staples_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorräte`)
};

/**
* | output |
* | --- |
* | "Staples" |
*
* @param {Staples_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staples_title = /** @type {((inputs?: Staples_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staples_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staples_title(inputs)
	return en_staples_title(inputs)
});